import request from '@/utils/request'

// 获取产品栏目树
// /api/cms/pnode/treeselect

// 点击产品列表（读取产品一级栏目以及一级栏目下产品）
// /api/cms/product/indexList

// 产品详情
// /api/cms/product/getInfo/{id}

// 根据栏目id查询产品列表（分页）
// /api/cms/product/list

// 获取产品栏目树
export const getTreeselect=(query)=> {
  return request({
    url: '/api/cms/pnode/nodeMenu',
    method: 'get',
    params: query
  })
}

//  点击产品列表（读取产品一级栏目以及一级栏目下产品）
export const getIndexList=(query)=> {
  return request({
    url: '/api/cms/product/indexList',
    method: 'get',
    params: query
  })
}

// 获取产品详情
export const getProductDetail=(query)=> {
  return request({
    url: '/api/cms/product/getInfo',
    method: 'get',
    params: query
  })
}

//  根据栏目id查询产品列表（分页）
export const getProductList=(query)=> {
  return request({
    url: '/api/cms/product/list',
    method: 'get',
    params: query
  })
}
// 根据栏目id获取栏目信息
export const getNodeInfo=(id)=> {
  return request({
    url: '/api/cms/node/'+id,
    method: 'get',
    // params: query
  })
}
// 根据nodeId获取全部面包屑列表 
export const getParentList=(query)=> {
  return request({
    url: '/api/cms/node/getParentList',
    method: 'get',
    params: query
  })
}


export const getProductNodeList=(nodeId,lanType)=> {
  return request({
    url: '/api/cms/pnode/nodeList?id='+nodeId+'&lanType='+lanType,
    method: 'get',
    // params: query
  })
}

export const getNode2List=(nodeId)=> {
  return request({
    url: '/api/cms/pnode/node2List?id='+nodeId,
    method: 'get',
    // params: query
  })
}
